import { type FC, useMemo, useState } from 'react';
import { ButtonMore } from '@/components/buttons';
import { useUserWageringBonuses } from '@/hooks/bonuses';
import { useGetCommonStore } from '@/store';
import { WagerLabel } from '../components/WagerLabel';
import type {
  ActionsPanelBasicProps,
  GameStateActions,
  MobileActionsPanelProps,
} from '../types';
import { ActionsMobile } from './components/ActionsMobile';

import { ScActionsPanelMobile } from './styled';

export const ActionsPanelMobile: FC<
  ActionsPanelBasicProps & MobileActionsPanelProps & GameStateActions
> = ({ handleToggleDemo, withTournamentBanner, ...props }) => {
  const useCommonStore = useGetCommonStore();

  const isMobileDevice = useCommonStore.use.isMobileDevice();
  const { hasWageringBonusByCurrency } = useUserWageringBonuses();

  const [isMobileActionPanelOpen, toggleMobileActionPanel] = useState(false);

  const actionsPanelProps = useMemo(
    () => ({
      handleToggleDemo: () => {
        handleToggleDemo();
        toggleMobileActionPanel(false);
      },
      onClose: () => toggleMobileActionPanel(false),
      ...props,
    }),
    [handleToggleDemo, props]
  );

  const shouldShowWageringLabel =
    hasWageringBonusByCurrency && isMobileDevice && !props.isDemo;

  return (
    <>
      <ScActionsPanelMobile withTournamentBanner={!!withTournamentBanner}>
        <div className="btn-wrapper">
          <ButtonMore
            active={!isMobileActionPanelOpen}
            onClick={() => {
              toggleMobileActionPanel(true);
            }}
            vertical
          />
        </div>

        {shouldShowWageringLabel && <WagerLabel />}
      </ScActionsPanelMobile>

      {isMobileActionPanelOpen ? (
        <ActionsMobile {...actionsPanelProps} />
      ) : null}
    </>
  );
};
